import { render, staticRenderFns } from "./ImageDropzone.vue?vue&type=template&id=dc94b7d4"
import script from "./ImageDropzone.vue?vue&type=script&lang=ts"
export * from "./ImageDropzone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports